import Animation from './Animation';
import './LevelBreak.css';
import { play } from '../../../SoundManager';

export default class LevelUp extends Animation {

	constructor (master) {

		super(master, 3500);
		//this.loadAudio("heartbeat", 1000);
	}

	run () {

		var el = document.querySelector(".level-up-screen");
		if (el) {
			setTimeout(() => play('heartbeatsoft', 'sfx', 'scene'), 600);
			setTimeout(() => play('heartbeatsoft', 'sfx', 'scene'), 1200);
			setTimeout(() => play('heartbeatsoft', 'sfx', 'scene'), 1700);
			setTimeout(() => play('heartbeatsoft', 'sfx', 'scene'), 2200);
			setTimeout(() => play('heartbeat', 'sfx', 'scene'), 3100);
			el.classList.add("level-break-animation");
			setTimeout(() => el.classList.remove("level-break-animation"), 6000);
		}
	}
}